import { render } from "./InfoSection.vue?vue&type=template&id=f92d5a40&scoped=true"
import script from "./InfoSection.vue?vue&type=script&lang=js"
export * from "./InfoSection.vue?vue&type=script&lang=js"

import "@/Common/Styles/viewCollection.scss?vue&type=style&index=0&id=f92d5a40&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f92d5a40"]])

export default __exports__